import { render, staticRenderFns } from "./ListSocialTypeView.vue?vue&type=template&id=6c1e39f5"
import script from "./ListSocialTypeView.vue?vue&type=script&lang=ts"
export * from "./ListSocialTypeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports